import { NavBar } from "./NavBar";

export function PageWrapper({
  children,
  className = "",
  pageClassName = "",
  ...props
}: {
  children: React.ReactNode;
  pageClassName?: string;
} & React.ComponentPropsWithoutRef<"main">) {
  return (
    <div className={`min-h-screen ${pageClassName}`}>
      <div
        className={
          "relative isolate mx-auto flex w-full max-w-lg flex-col justify-between px-4 lg:px-0"
        }
      >
        <NavBar className="py-4 sm:py-8 md:py-10" />
      </div>
      <main className={`px-4 pb-48 ${className}`} {...props}>
        {children}
      </main>
    </div>
  );
}
